<ng-container>
  @if (contextService.contextObject && !_environment.production && contextService.contextObject?.apiBaseUrlV1) {
    <div class="ut-apidomain" [ngClass]="{'mobile-api' : isMobile}"><b>NOT PRODUCTION</b> -
      API: {{ contextService.contextObject.apiBaseUrlV1 }}
    </div>
  }
  @if (isAuthenticated && (userAgreement || contextService.contextObject.tenantName !== 'IUPAT') && !isPublic) {
    <app-header [showMenuSelect]="ShowMenuSelect"
                [parentShowBurger]="parentShowBurger" (MenuSelect)="menuSelect($event)"
                (MenuViewSelect)="menuViewSelect($event)" [ngClass]="{'mobile-nav' : isMobile}"
    ></app-header>
    @if (topNav) {
      <app-header-nav [selectedMenuView]="selectedMenuView"></app-header-nav>
    }
  }
  <!--  <ng-sidebar-container #appSelect [ngStyle]="{'height': opened ? 'calc(100% - 86px)' : (!dataPerspectiveDescription && !isPublic ? 'calc(100% - 104px)' : (isPublic ? 'calc(100%)' : 'calc(100% - 123px)'))}">-->
  <div #appSelect [ngStyle]="{'height': opened ? 'calc(100% - 86px)' : (!dataPerspectiveDescription && !isPublic ? 'calc(100% - 104px)' : (isPublic ? 'calc(100%)' : 'calc(100% - 123px)'))}"
       class="ng-sidebar-container">
    @if (isAuthenticated && (userAgreement || contextService.contextObject.tenantName !== 'IUPAT')) {
      @if (!topNav) {
        <p-drawer class="side-bar" [(visible)]="opened" [modal]="false"
                  (onHide)="opened = false; sidenavService.updateMenuSideBar()">
          <app-side-nav [selectedMenuView]="selectedMenuView"></app-side-nav>
        </p-drawer>
      }
      <p-drawer class="alertSidebar" position="right" [(visible)]="isAlertsOpened" [modal]="!isMobile"
                (onHide)="isAlertsOpened = false; sidenavService.updateAlertSideBar()">
        <app-alerts-sidebar (close)="closeAlerts()" [showAlerts]="isAlertsOpened"></app-alerts-sidebar>
      </p-drawer>
    }
    <div [className]="'ng-sidebar-content'" [ngClass]="{'mobile-wrapper' : isMobile}" [ngStyle]="{'padding-left': (opened && !isMobile) ? '240px' : '0px'}">
      <div class="full-width">
        <ng-scrollbar #scrollable appearance="compact" pointerEventsMethod="scrollbar" track="all" visibility="hover">
          @if (isAuthenticated && (userAgreement || contextService.contextObject.tenantName !== 'IUPAT') && dataPerspectiveDescription) {
            <h2 class="align-center p-mt-3 p-mb-1" style="color: #4A4A4A;"><strong><i class="fas fa-eye eye"
                                                                                      pTooltip="Data Perspective"
                                                                                      tooltipPosition="bottom"></i> {{ dataPerspectiveDescription }}</strong>
            </h2>
          }
          <router-outlet class="content"></router-outlet>
        </ng-scrollbar>
      </div>
    </div>
  </div>
</ng-container>
@if (isAuthenticated) {
  <footer id="footer">
    <div class="menu-container">
      <a id="aUniontrack" class="ut-navigation ut-saveexclude" href="https://www.uniontrack.com"
         rel="noopener noreferrer" target="_blank" title="UnionTrack, Inc">&copy; {{ copyYear }},
        UnionTrack<sup>&reg;</sup></a>
      <div style="float: right; margin-bottom: 5px;">
        Required
       <sup class="req">*</sup>
      </div>
    </div>
  </footer>
} @else {
  <footer class="full-width text-align-middle unauthFooterContainer">
    <a class="ut-navigation unauthFooter" href="https://www.uniontrack.com"
       rel="noopener noreferrer" target="_blank" title="UnionTrack, Inc">&copy; {{ copyYear }},
      UnionTrack<sup>&reg;</sup></a>
  </footer>
}
<p-confirmdialog [baseZIndex]="19000" [draggable]="false"></p-confirmdialog>
<p-confirmdialog [baseZIndex]="10000" key="validationFailed" [draggable]="false"></p-confirmdialog>
<p-confirmdialog [baseZIndex]="10000" key="suspension" [draggable]="false"></p-confirmdialog>
<p-confirmdialog [baseZIndex]="10000" key="exemptCodes" [draggable]="false" >
  <ng-template #message let-message>
    <div class="exempt-codes-dialog" [innerHTML]="message.message"></div>
  </ng-template>
</p-confirmdialog>
